import { render, staticRenderFns } from "./Newscenter.vue?vue&type=template&id=0a0930fc&scoped=true"
import script from "./Newscenter.vue?vue&type=script&lang=js"
export * from "./Newscenter.vue?vue&type=script&lang=js"
import style0 from "./Newscenter.vue?vue&type=style&index=0&id=0a0930fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0930fc",
  null
  
)

export default component.exports